/**
 * @generated SignedSource<<386cb530a3758aca88c75b3201779308>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesLaunchCard_LaunchCard$data = {
  readonly canEdit: boolean;
  readonly driverData: {
    readonly driver: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly project: {
    readonly cloudId: string;
    readonly key: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesLaunchCard_AsyncVersionContributors" | "async_softwareReleasesLaunchCard_AsyncVersionStatus" | "latestDeployment_softwareReleasesLaunchCard_jiraVersion" | "ui_softwareReleasesVersionDriverField_DriverField" | "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription" | "versionDates_softwareReleasesLaunchCard">;
  readonly " $fragmentType": "ui_softwareReleasesLaunchCard_LaunchCard";
};
export type ui_softwareReleasesLaunchCard_LaunchCard$key = {
  readonly " $data"?: ui_softwareReleasesLaunchCard_LaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesLaunchCard_LaunchCard">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "name": "ui_softwareReleasesLaunchCard_LaunchCard",
  "selections": [
    {
      "condition": "isDevopsFeatureDisabledInFedRamp",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion"
        },
        {
          "kind": "FragmentSpread",
          "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "versionDates_softwareReleasesLaunchCard"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionDriverField_DriverField"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription"
    },
    {
      "kind": "RequiredField",
      "field": (v0/*: any*/),
      "action": "THROW",
      "path": "id"
    },
    {
      "concreteType": "JiraVersionDriverResult",
      "kind": "LinkedField",
      "name": "driverData",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "driver",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "canEdit"
      },
      "action": "THROW",
      "path": "canEdit"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "cloudId"
            },
            "action": "THROW",
            "path": "project.cloudId"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "project.key"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "895f1ae46eb71f223dc9353087cec375";

export default node;
